import { Command } from 'cmdk';

import { IconPlus } from '../../icons/cdl/Plus';
import { useGlobalCreateActions } from '../hooks/useGlobalCreateActions';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandEmptyState } from './CommandEmptyState';
import { CommandItem } from './CommandItem';

export const Create = () => {
    const { setOpen } = useShortcutMenu();
    const createItems = useGlobalCreateActions();

    if (!createItems.length) {
        return <CommandEmptyState />;
    }

    return (
        <Command.List>
            <Command.Empty>
                <CommandEmptyState />
            </Command.Empty>
            {createItems.map((item) => (
                <CommandItem
                    key={item.id}
                    value={item.label}
                    Icon={IconPlus}
                    iconVisibility="selected"
                    onSelect={() => {
                        setOpen(false);
                        item.onSelect();
                    }}
                >
                    {item.label}
                </CommandItem>
            ))}
        </Command.List>
    );
};
